module.exports = "\r\n.form-group label{\r\n    color: blue;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/hrms/payroll/payroll-process-details/payroll-attendace-leave/payroll-attendace-leave.component.css
// module id = ./src/app/hrms/payroll/payroll-process-details/payroll-attendace-leave/payroll-attendace-leave.component.css
// module chunks = main